import React, { Component } from 'react';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import './estilo.css';
import TaxiIcon from '../../img/taxiUbicacion1.png';
import PrivadoIcon from '../../img/privadoUbicacion.png';
import MicroIcon from '../../img/microbus.png';
import CoasterIcon from '../../img/coaster.png';


class AignaViajes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viajesD: [],
            bases: [],
            baseFill: '',
            tipoV: [],
            cantT: 0,
            cantM: 0,
            cantC: 0,
            cantP: 0,
            empresas:[],
            solicitante:''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleVehiculoViaje = this.handleVehiculoViaje.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.obteViajes();
        firebase.database().ref('Bases').once('value').then(snap => {
            let bases = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                bases.push(datos);
            });
            this.setState({ bases })
        })
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let tipoV = [];
            snap.forEach(element => {
                let data = element.val();
                tipoV.push(data);
            });
            this.setState({ tipoV })
        })
        firebase.database().ref('Empresa').once('value').then(snap =>{
            let empresas = [];
            snap.forEach(element => {
                let data = element.val();
                data.key = element.key;
                empresas.push(data);
            });
            this.setState({ empresas })
        })
        this.contarVehi();
    }

    handleChange(event) {
        this.setState({ baseFill: event.target.value, viajesD: [] });
        this.obteViajes();
        setTimeout(() => {
            this.contarVehi();
        }, 500);
    }

    contarVehi = () => {
        firebase.database().ref('LaboresEmpresa').once('value', data => {
            let taxi = 0;
            let priva = 0;
            let micro = 0;
            let coaster = 0;
            data.forEach(element => {
                let objeCont = element.val();
                if (objeCont.base === this.state.baseFill || this.state.baseFill === '') {
                    if (objeCont.tipoV === 'Taxi') {
                        taxi = taxi + 1;
                    }
                    if (objeCont.tipoV === 'Microbus') {
                        micro = micro + 1;
                    }
                    if (objeCont.tipoV === 'Privado') {
                        priva = priva + 1;
                    }
                    if (objeCont.tipoV === 'Coaster') {
                        coaster = coaster + 1;
                    }
                }
            });

            this.setState({ cantT: taxi, cantM: micro, cantP: priva, cantC: coaster })
        })
    }

    obteViajes = () => {
        this.setState({ viajesD: [] })
        firebase.database().ref().child('Programacion').orderByChild('horaReco').once('value', snap => {
            snap.forEach(element => {
                let datos = element.val();
                firebase.database().ref('Programacion/' + element.key + '/frecuencia').once('value').then(snap2 => {
                    snap2.forEach(element2 => {
                        let fechas = element2.val();
                        let fechaR = new Date(fechas.valor);
                        let fechaD = fechaR.getFullYear() +'/'+ (fechaR.getMonth()+1) +'/'+ fechaR.getDate();
                        let fechaF = new Date(fechaD);
                        let fechaS = new Date();
                        let fechaB = fechaS.getFullYear() +'/'+ (fechaS.getMonth()+1) +'/'+ fechaS.getDate();
                        let fechaC = new Date(fechaB);
                        if (fechaF.getTime() === fechaC.getTime()) {
                            let empleL = 0;
                            let recogida = '';
                            let baseA = '';
                            let baseB = '';
                            firebase.database().ref().child('ProgramacionDia').orderByChild('idH').equalTo(element2.key).once('value').then(snap3 => {
                                let empleados = [];
                                snap3.forEach(element => {
                                    let obje = element.val();
                                    if (obje.estado !== 'Cancelado') {
                                        empleados.push(obje.emple)
                                        empleL = empleL + 1;
                                        baseA = obje.baseI;
                                        baseB = obje.baseF;
                                    }
                                });

                                firebase.database().ref('Bases/' + baseA).once('value').then(snap4 => {
                                    if (this.state.baseFill === baseA || this.state.baseFill === '') {
                                        let data = snap4.val();
                                        firebase.database().ref('Bases/' + baseB).once('value').then(snap7 => {  
                                            let data7 = snap7.val();
                                            firebase.database().ref().child('AsignacionViajes').orderByChild('hijos').equalTo(element2.key).once('value').then(snapshot => {
                                                let existe = snapshot.val();
                                                if (existe !== null) {
                                                    snapshot.forEach(element2 => {
                                                        if(datos.solicitante === this.state.solicitante || this.state.solicitante === ''){
                                                            let existe = element2.val();
                                                            let datoss = { nombV: datos, idPro: element.key, nh: element2.key, cantL: empleL, recogida, base: data.Nombre, idPD: empleados, baseK: snap4.key, tipo: existe.tipoVe, movil: existe.movil }
                                                            let index = this.state.viajesD.length;
                                                            this.darValores(empleados, index, 'Taxi', snap4.key, element.key, data.latitud+','+data.longitud, data7.latitud+','+data7.longitud )
                                                            this.setState({ viajesD: [...this.state.viajesD, datoss] });
                                                        } 
                                                    });
                                                }
                                                else {
                                                    if(datos.solicitante === this.state.solicitante || this.state.solicitante === ''){
                                                        let datoss = { nombV: datos, idPro: element.key, nh: element2.key, cantL: empleL, recogida, base: data.Nombre, idPD: empleados, baseK: snap4.key, tipo: '' }
                                                        let index = this.state.viajesD.length;
                                                        this.darValores(empleados, index, 'Taxi', snap4.key, element.key,data.latitud+','+data.longitud, data7.latitud+','+data7.longitud)
                                                        this.setState({ viajesD: [...this.state.viajesD, datoss] });
                                                    }
                                                }
                                            })   
                                        })
                                    }
                                })
                            })
                        }
                    });
                })
            });
        })
    }


    handleVehiculoViaje = (id, index, event, base, idPro) => {
        let id3 = 'sele' + index;
        let objeto = { tipo: event.target.value, idPD: id, base, idPro }
        this.setState({ [id3]: objeto });
    }

    darValores(id, index, event, base, idPro, inicio,destino) {
        let id3 = 'sele' + index;
        let objeto = { tipo: event, idPD: id, base, idPro, inicio, destino }
        this.setState({ [id3]: objeto });
    }

    handleChangeE = (event) =>{
        this.setState({ solicitante: event.target.value, viajesD: [] });
        this.obteViajes();
        setTimeout(() => {
            this.contarVehi();
        }, 500);
    }

    handleSave = (index, hijos) => {
        let id3 = 'sele' + index;
        firebase.database().ref('LaboresEmpresa').once('value').then(snap => {
            let menor = 999999999;
            let conduc = '';
            let tipoVe = '';
            let datoE = ''
            snap.forEach(element => {
                let data = element.val();
                if (data.cooncordancia < menor && data.tipoV === this.state[id3].tipo && data.estado === "true" && this.state[id3].base === data.base) {
                    menor = data.cooncordancia;
                    conduc = data.emple;
                    tipoVe = data.tipoV;
                    datoE = element.key;
                }
            });

            firebase.database().ref().child('AsignacionViajes').orderByChild('prograP').equalTo(this.state[id3].idPro).once('value').then(snapshot => {
                let existe = snapshot.val()
                if (existe === null) {
                    if(menor === 999999999){
                        if(this.state[id3].base === 'Bases'){
                            Alert.error('El viaje debe tener almenos un pasajero para que pueda asignar el viaje', {
                                effect: 'genie',
                                position: 'bottom-right',
                                timeout:3000,
                                html:true			
                            });
                        }else{
                            Alert.error('No posee vehiculos de este tipo disponibles actualmente para esta base', {
                                effect: 'genie',
                                position: 'bottom-right',
                                timeout:3000,
                                html:true			
                            });
                        }
                        }
                    else{
                        let fecha = new Date();
                        firebase.database().ref('Empleados/' + conduc).once('value').then(data => {
                            let emple = data.val();
                            firebase.database().ref('Vehiculos/' + emple.vehiculo).once('value').then(dataV => {
                                let vehi = dataV.val();
                                let idCreado = firebase.database().ref().child('AsignacionViajes').push({
                                    emple: '',
                                    conduc,
                                    fecha: fecha.toString(),
                                    estado: "true",
                                    prograP: this.state[id3].idPro,
                                    base: this.state[id3].base,
                                    tipoVe,
                                    horaIni: "",
                                    horaFin: "",
                                    movil: vehi.movil,
                                    viajeIniciado: false,
                                    viajeFinalizado: false,
                                    tipoViaje:'comun',
                                    hijos:hijos.nh,
                                    inicio:this.state[id3].inicio,
                                    destino:this.state[id3].destino

                                })
                                var messageRef = firebase.database().ref("AsignacionViajes/" + idCreado.key + "/emple/");
                                this.state[id3].idPD.forEach(element => {
                                    messageRef.push({
                                        idEmple: element,
                                        subio: false,
                                        horaSubida: ''
                                    })
                                })
                                firebase.database().ref().child('Empleados/' + conduc).update({
                                    viajeEmpresa: 'No disponible',
                                    ViajeActualE: idCreado.key
                                })
                                firebase.database().ref().child('EmpleadosGPS/' + conduc).update({
                                    viajeEmpresa: 'No disponible',
                                    ViajeActualE: idCreado.key
                                })
                                this.obteViajes();
                                firebase.database().ref('LaboresEmpresa').child(datoE).remove();
                                firebase.database().ref('LaboresEmpresa').once('value').then(data => {
                                    data.forEach(element => {
                                        let emple = element.val();
                                        let numero = emple.cooncordancia;
                                        if (numero > menor && this.state[id3].base === emple.base) {
                                            firebase.database().ref().child('LaboresEmpresa/' + element.key).update({
                                                cooncordancia: (numero - 1),
                                            })
                                        }
                                    });
                                })
                                Alert.success('Conductor asignado exitosamente', {
                                    effect: 'genie',
                                    position: 'bottom-right',
                                    timeout: 3000,
                                    html: true
                                });
                            })
                        })
                    }
                }
                else {
                    Alert.warning('Este viaje ya posee conductor asigando', {
                        effect: 'genie',
                        position: 'bottom-right',
                        timeout: 3000,
                        html: true
                    });
                }
            })
        })
    }

    render() {
        let { viajesD, bases, tipoV, cantT, cantM, cantP, cantC, baseFill, empresas,solicitante } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <form>
                            <div className="form-row align-items-center">
                                <div className="col-sm-1 my-1">
                                    <label className="text-gray">Filtros</label>
                                </div>
                                <div className="col-sm-2 my-1">
                                    <select value={solicitante} onChange={this.handleChangeE} className="form-control bg-select my-1 mr-sm-2">
                                        <option value={''} >Todas las Empresas</option>
                                        {empresas.map((snap, index) => {
                                            return (
                                                <option key={'opcion3' + index} value={snap.key}>{snap.codigo_empresa}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-sm-2 my-1">
                                    <select value={baseFill} onChange={this.handleChange} className="form-control bg-select my-1 mr-sm-2">
                                        <option value={''} >Todas las bases</option>
                                        {bases.map((snap, index) => {
                                            return (
                                                <option key={'opcion2' + index} value={snap.key}>{snap.Nombre}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-sm-9 restinge" >
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Viaje</th>
                                        <th>Hora de recogimiento</th>
                                        <th>Origen</th>
                                        <th>Pasajeros</th>
                                        <th>Unidad /es</th>
                                        <th>Asignar seguridad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viajesD.map((snap, index) => {
                                        return (
                                            <tr key={index}>
                                                {snap.nombV.tipo === 'pilotos' &&
                                                    <td><button style={{ width: 160 }} className="btn btn-purple">{snap.nombV.vuelo}</button></td>
                                                }
                                                {snap.nombV.tipo === 'tcs' &&
                                                    <td><button style={{ width: 160 }} className="btn btn-greenR">{snap.nombV.vuelo}</button></td>
                                                }
                                                {snap.nombV.tipo === 'pilotossap' &&
                                                    <td><button style={{ width: 160 }} className="btn btn-orange">{snap.nombV.vuelo}</button></td>
                                                }
                                                {snap.nombV.tipo === 'tcssap' &&
                                                    <td><button style={{ width: 160 }} className="btn btn-sap">{snap.nombV.vuelo}</button></td>
                                                }
                                                <td>{snap.nombV.horaReco}</td>
                                                <td>{snap.base}</td>
                                                <td>{snap.cantL}</td>
                                                <td>
                                                    {snap.tipo === '' &&
                                                        <div>--</div>
                                                    }
                                                    {snap.tipo !== '' &&
                                                        <div>
                                                            {snap.tipo === 'Taxi' &&
                                                                <div><img src={TaxiIcon} width="30" height="37" /> <p>{snap.movil}</p></div>
                                                            }
                                                            {snap.tipo === 'Microbus' &&
                                                                <div><img src={MicroIcon} width="30" height="37" /> <p>{snap.movil}</p></div>
                                                            }
                                                            {snap.tipo === 'Privado' &&
                                                                <div><img src={PrivadoIcon} width="30" height="37" /> <p>{snap.movil}</p></div>
                                                            }
                                                            {snap.tipo === 'Coaster' &&
                                                                <div><img src={CoasterIcon} width="30" height="37" /> <p>{snap.movil}</p></div>
                                                            }
                                                        </div>
                                                    }
                                                </td>
                                                <td>
                                                    <div className="width-select">
                                                        <select onChange={(event) => this.handleVehiculoViaje(snap.idPD, index, event, snap.baseK, snap.idPro)} className="form-control bg-select">
                                                            {tipoV.map((snap, index) => {
                                                                return (
                                                                    <option key={'opcion' + index} value={snap.tipo}>{snap.tipo}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                </td>
                                                <td>
                                                    <button onClick={() => this.handleSave(index,snap)} className="btn btn-small-green">+</button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-12 col-sm-3">
                        <div className="col-12">
                            <h5 className="m-top-h5">Unidades Disponibles</h5>
                        </div>
                        <div className="col-12 bg-card">
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={TaxiIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantT}</h5>
                                        <span className="text-info">Taxis</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4 ">
                                        <img src={PrivadoIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantP}</h5>
                                        <span className="text-info">Privados</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={MicroIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantM}</h5>
                                        <span className="text-info">Microbuses</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row mar-bottom">
                                    <div className="col-12 col-sm-4">
                                        <img src={CoasterIcon} className="m-top" width="65" height="42" />
                                    </div>
                                    <div className="col-12 col-sm-8 m-top">
                                        <h5 className="m-bottom-none">{cantC}</h5>
                                        <span className="text-info">Coaster</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AignaViajes;




// WEBPACK FOOTER //
// ./src/Components/Planificacion/asignacionViajes.js